export function isReportCardReport(props) {
  return 'report' in props;
}

// used on multiconfig reports